export default __webpack_public_path__ + "fd05df59a71fe4b1df4a000df8a20572.svg";